/**
 * DAM routes
 *
 * @author Rohit Biswas (rbiswas@yext.com)
 */
goog.declareModuleId('yext.dam.routes');

import * as router from '/js/yext/storm/router';

export default {
  view: router.route('assets/manage'),
  locationDestinationSearch: router.route('assets/manage/locationDestinations'), // Only used in DAM LocationSearchTooltip
  search: router.route('assets/search'), // Only used in AssetSelector search.js
  uploadEndpoint: router.route('assets/photo/upload'), // Dam still maintains its own upload endpoint.
  loadLabels: router.route('assets/label/load'),
  getLabelsOnAssets: router.route('assets/getLabelsOnAssets'), // Only used in AssetSelector
  viewAsset: router.route('assets/edit'),
  validateAssetScope: router.route('assets/validateAssetScope'), // Only used in PostBox
  // External Images
  externalImageUrlEndpoint: router.route('photos/fetchByUrl'), // Routes to PhotoServer.
  editSaveField: router.route('assets/editField'),
};
